// Los diálogos de SweetAlert se abren fuera de React: los colores se leen de las
// variables CSS que Chakra pone en la página (el color de la empresa y el modo noche).

const variableCss = (nombre, respaldo) => {
  if (typeof document === "undefined") return respaldo;
  return getComputedStyle(document.documentElement).getPropertyValue(nombre).trim() || respaldo;
};

/** Para mezclar en Swal.fire({ ...estiloAlerta(), ... }). Un color propio va después. */
export const estiloAlerta = () => ({
  theme: typeof document !== "undefined" && document.body.classList.contains("chakra-ui-dark") ? "dark" : "light",
  confirmButtonColor: variableCss("--chakra-colors-brand-500", "#00afef"),
  cancelButtonColor: "#718096",
});

export default estiloAlerta;
